/*登录分路由*/
export default {
  path: '/login',
  component: resolve => require(['@/views/login/login.vue'], resolve)
}
